import React from "react";
import {
    Box,
    Typography,
    Container,
    Paper,
    Grid,
    Avatar,
} from "@mui/material";
import { anmol, avani, dell, ds, Homeimages, ira, landmark, magnifiq, ornate, pvr, salasar, sastel, sreenidhi, suchindra, tar, tejase } from "../../assets";
export const experienceData = [
    {
        id: 1,
        title: "Rajiv Williams - Luxury Sales Mastery",
        role: "Luxury Sales Mentor • Coach & Consultant",
        location: "Hyderabad Area, India",
        image: Homeimages.bluelogo,
        points: [
            "Elite luxury real estate sales mentor empowering investors, developers, and high-performing professionals through psychology-driven consultative selling systems (SPIN, NEAT, NLP) delivering measurable ROI."
        ]
    },
    {
        id: 2,
        title: "Dezign Shark",
        role: "Business Owner",
        location: "Hyderabad, Telangana, India",
        image: ds,
        points: [
            "360° Branding, Advertising & Media Company providing end-to-end services including personal branding, content marketing, social media strategy, and performance marketing for SMBs and enterprises."
        ]
    },
    {
        id: 3,
        title: "Tejase Developers",
        role: "Sales Mentor",
        location: "Hyderabad, Telangana, India",
        image: tejase,
        points: [
            "One of the fastest-growing real estate developers in the Golden Triangle Region.",
            "Worked with strong technical team to deliver value proposition at lucrative pricing.",
            "Contributed to landmark projects like TRANQUIL CREEK at MOKILA."
        ]
    },
    {
        id: 4,
        title: "IRA Realty India",
        role: "Sales & Marketing Mentor",
        location: "Hyderabad, Telangana, India",
        image: ira,
        points: [
            "IRA M3 - Premium gated community of 2 BHK apartments located 15 minutes from Kokapet & Financial District at Kollur."
        ]
    },
    {
        id: 5,
        title: "TAR Group Official",
        role: "Organizational Mentor",
        location: "Hyderabad, Telangana, India",
        image: tar,
        points: [
            "Premium real estate developer specializing in ultra-luxury condos (6000 Sft 4 BHK residences) and sky villas (8000 Sft).",
            "Projects located in Manchirevula and upcoming villa community at Kandlakoya."
        ]
    },
    {
        id: 6,
        title: "Suchirindia",
        role: "Business Mentor",
        location: "Hyderabad, Telangana, India",
        image: suchindra,
        points: [
            "19 years of expertise in open plotting, gated apartments, luxury villas, hotels & resorts across Hyderabad."
        ]
    },
    {
        id: 7,
        title: "Ornate Interiors",
        role: "Strategic Partner",
        location: "Hyderabad, Telangana, India",
        image: ornate,
        points: [
            "Built a structured growth ecosystem ensuring smooth cash flow, operational clarity, and strong stakeholder visibility while strengthening lead generation, corporate communication, customer handling, telesales, and content-driven marketing initiatives."
        ]
    },
    {
        id: 8,
        title: "Landmark Group India",
        role: "Organizational Mentor",
        location: "Hyderabad, Telangana, India",
        image: landmark,
        points: [
            "Established a performance-driven sales ecosystem integrating technology, process discipline, and continuous upskilling to generate consistent cash flow, while mentoring sales leaders to build empowered teams through empathy-led, insight-driven selling."
        ]
    },
    {
        id: 9,
        title: "Shri Salasar Developers",
        role: "Strategic Partner",
        location: "Hyderabad, Telangana, India",
        image: salasar,
        points: [
            "Premium luxury residential real estate construction organization with uber-class standards."
        ]
    },
    {
        id: 10,
        title: "Sreenidhi Estate",
        role: "Strategic Partner",
        location: "Shamshabad, Telangana, India",
        image: sreenidhi,
        points: [
            "Sales PMC for prestigious villa project Phoenix Luxury Park 2 at Shamshabad, Mamidipally."
        ]
    },
    {
        id: 11,
        title: "Avani Projects",
        role: "Strategic Partner",
        location: "Hyderabad, Telangana, India",
        image: avani,
        points: [
            "Real estate development organization with apartments to luxury farmhouse projects in Western Hyderabad."
        ]
    },
    {
        id: 12,
        title: "Magnifiq Properties",
        role: "Strategic Partner",
        location: "Hyderabad, Telangana, India",
        image: magnifiq,
        points: [
            "Property management and asset liquidation company."
        ]
    },
    {
        id: 13,
        title: "Anmol Constructions Hyd",
        role: "Organizational Mentor",
        location: "Hi-Tech City",
        image: anmol,
        points: [
            "Established and turnkey-executed the complete end-to-end sales ecosystem, driving brand positioning, leadership development, HR structuring, marketing (ATL & BTL), digital integration, process excellence, client relationship management, negotiation mastery, and consistent cash flow generation."
        ]
    },
    {
        id: 14,
        title: "PVR Developers India PVT. LTD.",
        role: "Director Of Sales, Marketing & Business Development",
        location: "Hyderabad, Telangana, India",
        image: pvr,
        points: [
            "Led sales, marketing, and business development for a premium real estate developer, building national and international investor networks while driving strategic growth initiatives, revenue expansion, leadership coaching, and sustainable cash flow generation."
        ]
    },
    {
        id: 15,
        title: "Systel",
        role: "Operations & Client Relations Manager",
        location: "Hyderabad Area, India",
        image: sastel,
        points: [
            "Managed operations & client relations ensuring seamless service delivery."
        ]
    },
    {
        id: 16,
        title: "Dell",
        role: "Sr. Process Executive",
        location: "Hyderabad Area, India",
        image: dell,
        points: [
            "Managed process execution & operational excellence at global technology company."
        ]
    }
];

const ProfessionalExperience = () => {
    return (
        <Box
            sx={{
                backgroundColor: "#f4f8fc",
                py: 10,
                px: { xs: 3, md: 20 },
            }}
        >
            <Container maxWidth="xl">

                {/* SECTION TITLE */}
                <Box
                                   sx={{
                                       display: "flex",
                                       alignItems: "center",
                                       gap: 2,
                                       mb: 4,
                                   }}
                               >
                                   <Typography
                                       variant="h4"
                                       sx={{
                                           fontFamily: "'Playfair Display', serif !important",
                                           fontSize: {xs:"20px",md:"50px"},
                                           fontWeight: 600,
                                           color: "#0f2e4d",
                                           whiteSpace: "nowrap",
                                       }}
                                   >
                                       Professional Experience
                                   </Typography>
               
                                   <Box
                                       sx={{
                                           flex: 1,
                                           height: "1px",
                                           background:
                                               "linear-gradient(to right, #0f63a5, transparent)",
                                       }}
                                   />
                               </Box>

                {/* GRID */}
                <Grid container spacing={6} columnSpacing={10}>
                    {experienceData.map((exp) => (
                        <Grid item xs={12} md={6} key={exp.id}>
                            <Paper
                                elevation={0}
                                sx={{
                                    position: "relative",
                                    background: "linear-gradient(145deg, #ffffff, #f9fbff)",
                                    borderRadius: "18px",
                                    p: 5,
                                    borderLeft: "6px solid #0f63a5", // KEEP BLUE STRIP
                                    boxShadow: "0 12px 30px rgba(15,99,165,0.08)",
                                    transition: "all 0.4s ease",
                                    overflow: "hidden",
                                    height: "75%",
                                    display: "flex",
                                    flexDirection: "column",

                                    "&:hover": {
                                        transform: "translateY(-6px)",
                                        boxShadow: "0 18px 45px rgba(15,99,165,0.18)",
                                    },
                                }}
                            >
                                <Grid container spacing={3} sx={{ flex: 1 }}>
                                    {/* TEXT CONTENT */}
                                    <Grid item xs={12} md={9} sx={{ order: { xs: 2, md: 'unset' } }}>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: "18px",
                                                color: "#0f2e4d",
                                                fontFamily: "'Playfair Display', serif !important",
                                                textAlign:'start'
                                            }}
                                        >
                                            {exp.title}
                                        </Typography>

                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontFamily: "'Lato', sans-serif !important",
                                                color: "#0f63a5",
                                                fontWeight: 600,
                                                mt: 0.5,
                                                mb: 0.5,
                                                fontSize: "16px !important",
                                                textAlign:'start'
                                            }}
                                        >
                                            {exp.role}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontSize: "14px !important",
                                                color: "#666",
                                                mb: 2,
                                                fontFamily: "'Lato', sans-serif !important",
                                                textAlign:'start'
                                            }}
                                        >
                                            {exp.location}
                                        </Typography>

                                        <Box
                                            component="ul"
                                            sx={{
                                                listStyleType: "disc",
                                                paddingLeft: "18px",
                                                margin: 0,
                                                "& li::marker": { color: "#0f63a5" },
                                            }}
                                        >
                                            {exp.points.map((point, index) => (
                                                <Box
                                                    component="li"
                                                    key={index}
                                                    sx={{
                                                        fontFamily: "'Lato', sans-serif !important",
                                                        fontSize: "14px !important",
                                                        color: "#444",
                                                        lineHeight: 1.8,
                                                        mb: 0.8,
                                                        listStyleType: "disc",
                                                        paddingLeft: "5px",
                                                        margin: 0,
                                                        "& li::marker": {
                                                            color: "#000",
                                                        },
                                                        textAlign: 'start'
                                                    }}
                                                >
                                                    {point}
                                                </Box>
                                            ))}
                                        </Box>
                                    </Grid>
                                    {/* LOGO BADGE */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={3}
                                        sx={{
                                            display: "flex",
                                            justifyContent: {xs:"start",md:"center"},
                                            alignItems: "flex-start",
                                            order: { xs: 1, md: 'unset' },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 120,
                                                height: 120,
                                                borderRadius: "16px",
                                                backgroundColor: "#f4f8fc",
                                                border: "1px solid rgba(15,99,165,0.15)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow:
                                                    "inset 0 0 15px rgba(15,99,165,0.05)",
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={exp.image}
                                                sx={{
                                                    maxWidth: "75%",
                                                    maxHeight: "75%",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default ProfessionalExperience;